<template>
  <div class="bgf5 pl20">
    <div class="coupon-tabs">
      <ul>
        <li :class="{'active':this.tabIndex==0}" @click="handleTabsChange(0)" style="cursor:pointer;text-align:center;">
          <div :class="{'active':this.tabIndex==0}">可用优惠券（{{this.couponTabs[0].count}}）</div>
        </li>
        <li :class="{'active':this.tabIndex==1}" @click="handleTabsChange(1)" style="cursor:pointer;text-align:center;">
          <div :class="{'active':this.tabIndex==1}">不可用优惠券（{{this.couponTabs[1].count}}）</div>
        </li>
      </ul>

      <div style="height:100%; padding-left:0;">
        <van-list v-show="this.tabIndex == 0" :finished="this.couponTabs[0].finished" :finished-text="''" @load="onLoad(0)" class="mt24">
          <iCoupon :data="this.couponTabs[0].data" v-if="this.couponTabs[0].data.length" page="MyCoupon" />
          <EmptyControl style="padding-top: 100px;" v-if="!this.couponTabs[0].data.length && this.couponTabs[0].finished" type='coupon'
            text="暂无可用优惠券哦～" />
        </van-list>
        <van-list v-show="this.tabIndex == 1" :finished="this.couponTabs[1].finished" :finished-text="''" @load="onLoad(1)" class="mt24">
          <iCoupon :data="this.couponTabs[1].data" v-if="this.couponTabs[1].data.length" page="MyCoupon" />
          <EmptyControl style="padding-top: 100px;" v-if="!this.couponTabs[1].data.length && this.couponTabs[1].finished" type='coupon'
            text="暂无可用优惠券哦～" />
        </van-list>
      </div>
    </div>
  </div>
</template>
<script>
  import EmptyControl from "@/components/EmptyControl"
  import { BaseMixin } from "@/mixins/BaseMixin"

  export default {
    name: "SelectCoupon",
    components: { EmptyControl },
    mixins: [BaseMixin],

    data() {
      let tab = {
        loading: false,
        finished: false,
        pageindex: 0,
        pageSize: 10,
        count: 0,
        data: []
      };
      return {
        tabIndex: 0,
        couponTabs: [tab, tab]
      };
    },

    async mounted() {
      await this.getCount(Count => {
        this.couponTabs[0].count = Count;
      }, 1, false);
      await this.getCount(Count => {
        this.couponTabs[1].count = Count;
      }, 2, false);
    },
    methods: {
      async handleTabsChange(slot) {
        if (this.tabIndex != slot) {
          this.tabIndex = slot;
          this.couponTabs[slot].pageindex = 1;
          this.couponTabs[slot].data = [];
          await this.loadData(slot);
        }

      },
      async getCount(call, type, isOverdue) {
        const res = await this.getAction("/api_coupon/Coupon/GetMyCoupons", {
          keyword: "",
          couponHoldState: type,
          isOverdue: isOverdue,
          pageNo: 1,
          pageSize: this.pageSize
        });
        if (res.IsSuccess) {
          call && call(res.Count);
        }
      },
      // 加载数据
      async onLoad(slot) {
        if (this.couponTabs[slot].pageindex == 0) {
          this.couponTabs[slot].finished = false;
        }
        this.couponTabs[slot].loading = true;
        this.couponTabs[slot].pageindex = this.couponTabs[slot].pageindex + 1;
        await this.loadData(slot);
        this.couponTabs[slot].loading = false;
      },
      async loadData(slot) {
        this.$hys.openLoading();
        const res = await this.getAction("/api_coupon/Coupon/GetMyCoupons", {
          keyword: "",
          couponHoldState: slot,
          isOverdue: slot == 2 ? true : false,
          pageNo: this.couponTabs[slot].pageindex,
          pageSize: this.couponTabs[slot].pageSize
        });
        this.$hys.clearLoading();
        if (this.couponTabs[slot].pageindex == 1) {
          this.couponTabs[slot].data = [];
        }
        if (res.IsSuccess && res.Data.length < this.couponTabs[slot].pageSize) {
          this.couponTabs[slot].finished = true;
        }
        if (res.IsSuccess) {
          this.couponTabs[slot].count = res.Count;
          let dataArr = [];
          if (res.Data) {
            res.Data.map(item => {
              let lrt = parseFloat(item.OutCouponIssueDto.DeductionLimit * 10).toFixed(2).toString();
              let l = {
                ...item,
                Goods: item.OutCouponIssueDto.OutCouponLimitGoodsDtos,
                UseRequire: item.OutCouponIssueDto.OutCouponUseRequireDto,
                BeginTime: item.ValidityBeginTime,
                EndTime: item.ValidityEndTime,
                FailureDays: item.OutCouponIssueDto.FailureDays,
                DeductionMode: item.OutCouponIssueDto.DeductionMode, //指定金额1，指定比例2，全额抵扣3
                DeductionLimit: item.OutCouponIssueDto.DeductionLimit,
                LimitF: item.OutCouponIssueDto.DeductionMode == 2 ?
                  lrt.indexOf(".") == -1 ? lrt : lrt.substring(0, lrt.indexOf(".")) : null,
                LimitL: item.OutCouponIssueDto.DeductionMode == 2 ?
                  lrt.indexOf(".") == -1 ? null : lrt.substring(lrt.indexOf("."), lrt.length).replace(/0/, "") : null
              };
              dataArr.push(l);
            });
          }
          this.couponTabs[slot].data = dataArr;
        } else {
          this.couponTabs[slot].finished = true;
        }
      }
    }
  }
</script>

<style lang="less" scoped>
  .coupon-tabs {
    text-align: left;
    margin: 0 auto;
    width: calc(100% - 20px);
    height: 662px;
    background: rgba(255, 255, 255, 1);
    border-radius: 2px;
    border: 1px solid rgba(232, 232, 232, 1);

    >ul {
      height: 68px;
      margin-left: 20px;
      margin-right: 20px;
      border-bottom: 2px solid #3183ec;
    }

    >ul li {
      font-size: 14px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 600;
      color: black;
      display: inline-block;
      margin-right: 50px;
      padding-top: 27px;
      padding-bottom: 16px;
      text-align: center;

      &.active {
        font-size: 16px;
        border-bottom: 4px solid #0f6ee9;
      }
    }

    >ul li div {
      font-weight: 400;

      &.active {
        color: #0f6eea;
        font-weight: 600;
      }
    }
  }

  .coupon-tabs-header {
    display: flex;

    width: 81px;
    height: 22px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 600;
    color: black;
    line-height: 22px;
  }
</style>